import axios from 'axios'

import { getAccessToken } from 'cng-common/helpers/access'
import settings from 'src/config/settings'

interface IExportTopPartnersParameters {
  mappings: Record<string, never>
}

export const exportTopPartners = async ({
  mappings,
}: IExportTopPartnersParameters): Promise<Blob> => {
  const { data } = await axios.post<Blob>(
    `${settings.httpsServices.partner360}/api/v0/reporting/exportTopPartners`,
    mappings,
    {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  )

  return data
}
